import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const moreOptions = css`
  @media only screen and (max-height: 600px) {
    overflow: auto;
    padding-top: 1px;
    padding-bottom: 1px;
    max-height: ${rem(60)};
  }
`

export const styles = {
  moreOptions,
}
